import { render, staticRenderFns } from "./LpuScheduleSkeleton.vue?vue&type=template&id=bfafdcee&"
import script from "./LpuScheduleSkeleton.vue?vue&type=script&lang=js&"
export * from "./LpuScheduleSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./LpuScheduleSkeleton.vue?vue&type=style&index=0&id=bfafdcee&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfafdcee')) {
      api.createRecord('bfafdcee', component.options)
    } else {
      api.reload('bfafdcee', component.options)
    }
    module.hot.accept("./LpuScheduleSkeleton.vue?vue&type=template&id=bfafdcee&", function () {
      api.rerender('bfafdcee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/LpuSchedule/components/common/LpuScheduleSkeleton.vue"
export default component.exports